"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationBarReducers = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _find = _interopRequireDefault(require("lodash/find"));

var _each = _interopRequireDefault(require("lodash/each"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var constants = _interopRequireWildcard(require("./../constants"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getActivePlaceholders(placeholders) {
  var sortedPlaceholder = (0, _sortBy["default"])((0, _cloneDeep["default"])(placeholders), ['added']);
  return {
    activePlaceHolderFullScreen: (0, _find["default"])(sortedPlaceholder, ['targetKey', 'fullscreen']),
    activePlaceHolderWizard: (0, _find["default"])(sortedPlaceholder, ['targetKey', 'wizard']),
    activePlaceHolderPage: (0, _find["default"])(sortedPlaceholder, ['targetKey', 'page'])
  };
}

function getMessages(state) {
  var obj = {
    fullScreenMessages: [],
    wizardMessages: [],
    pageMessages: []
  };

  for (var i = 0; i < state.messages.length; i++) {
    var message = state.messages[i];

    if (message) {
      if (message.target === 'fullscreen') {
        obj.fullScreenMessages.push(message);
      } else if (message.target === 'page') {
        obj.pageMessages.push(message);
      } else {
        if (state.activePlaceHolderWizard) {
          obj.wizardMessages.push(message);
        } else if (state.activePlaceHolderPage) {
          obj.pageMessages.push(message);
        } else {
          obj.fullScreenMessages.push(message);
        }
      }
    }
  }

  return obj;
}

var initialState = {
  messages: [],
  fullScreenMessages: [],
  wizardMessages: [],
  pageMessages: [],
  activePlaceHolderFullScreen: null,
  activePlaceHolderWizard: null,
  activePlaceHolderPage: null,
  placeholders: [],
  callback: null
};
exports.initialState = initialState;

var NotificationBarReducers = function NotificationBarReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case constants.SHOW:
      {
        var messages = (0, _cloneDeep["default"])(state.messages);
        messages.push(_objectSpread({}, action.payload));

        var newState = _objectSpread({}, state, {
          messages: messages
        });

        return _objectSpread({}, newState, {}, getMessages(newState));
      }

    case constants.HIDE_ALL:
      {
        (0, _each["default"])(state.messages, function (message) {
          if (message && message.callback) {
            message.callback();
          }
        });

        var _newState = _objectSpread({}, state, {
          messages: []
        });

        return _objectSpread({}, state, {}, getMessages(_newState));
      }

    case constants.HIDE:
      {
        var _messages = (0, _cloneDeep["default"])(state.messages);

        var message = (0, _find["default"])(_messages, function (message) {
          return message.id === action.id;
        });

        if (message && message.callback) {
          message.callback();
        }

        _messages = (0, _filter["default"])(_messages, function (message) {
          return message.id !== action.id;
        });

        var _newState2 = _objectSpread({}, state, {
          messages: _messages
        });

        return _objectSpread({}, _newState2, {}, getMessages(_newState2));
      }

    case constants.REGISTER_PLACEHOLDER:
      {
        var placeholders = (0, _cloneDeep["default"])(state.placeholders);
        placeholders.push({
          targetKey: action.targetKey,
          id: action.id,
          added: new Date().getTime()
        });
        var activePlaceHolders = getActivePlaceholders(placeholders);

        var _newState3 = _objectSpread({}, state, {
          placeholders: placeholders
        }, activePlaceHolders);

        return _objectSpread({}, _newState3, {}, getMessages(_newState3));
      }

    case constants.UNREGISTER_PLACEHOLDER:
      {
        // determine active placeholder
        var _placeholders = (0, _cloneDeep["default"])(state.placeholders);

        _placeholders = (0, _filter["default"])(_placeholders, function (item) {
          return item.id !== action.id;
        });
        var activePlaceholders = getActivePlaceholders(_placeholders);

        var _newState4 = _objectSpread({}, state, {
          placeholders: _placeholders
        }, activePlaceholders);

        return _objectSpread({}, _newState4, {}, getMessages(_newState4));
      }
  }

  return state;
};

exports.NotificationBarReducers = NotificationBarReducers;